import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import { formatDate } from '../Utils/GlobalUtils';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import CardOfCase from '../Components/CardOfCase';
import HeaderPanel from '../Components/HeaderPanel';

import Loading from '../Components/Loading';

import styles from '../styles/Inbox.module.css';

const Inbox = () => {
  const { openTimeModal } = useTimeModal();
  
  const [isCardOfCase, setIsCardOfCase] = React.useState(false);
  const [idCaseForModal, setIdCaseForModal] = React.useState('');

  const [notifications, setNotifications] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [reload, setReload] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');
      axios.get('/api/inbox', {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      }).then(response => {
          if (response.data.length === 0) {
              setWarning('Уведомлений нет.');
              setNotifications([]);
          } else {
              setWarning('');
              setNotifications(response.data);
          }
      })
      .catch(error => {
          setWarning(`Ошибка при загрузке уведомлений:  ${error.response?.data.message || error.message}`);
      })
      .finally(() => {
        setReload(false);
        setLoading(false);
      })
  }, [reload]);

  const hideNotification = (id) => {
    const token = localStorage.getItem('token');
    axios.put(`/api/hide-notification?id=${id}`, {}, {
      headers: {
          Authorization: `Bearer ${token}`,
      }
    }).then(() => {
        setReload(true);
    })
    .catch(() => {
        openTimeModal('Не удалось скрыть уведомление. Попробуйте перезагрузить страницу', 'error')
    })
  };

  return (
    <>
    {isCardOfCase && <CardOfCase closeModal={() => {setIsCardOfCase(false)}} id={idCaseForModal} onCardOfCaseSuccess={() => {}} />}

    <div className='mainContainer'>
        <h1>Уведомления</h1>
        <HeaderPanel typePanel='Назад' />
        <div style={{marginTop: '7px'}}></div>
        <motion.div
            initial={{ scale: '97%', opacity: 0 }}
            animate={{ scale: '100%', opacity: 1 }}
            exit={{ scale: '97%', opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            {loading ? <Loading />
            : warning ? <div className='case warningLine'><a>{warning}</a></div>
            : notifications.map((notif) => (
                <div className={styles.line} key={notif.id}>
                  <a className={styles.date}>{formatDate(notif.created_at)}</a>
                  <a className={styles.contentNotification}>{notif.content}</a>
                  {notif.case_id && 
                    <a className={styles.additionalContent} onClick={() => {setIsCardOfCase(true); setIdCaseForModal(notif.case_id)}}>
                      <button type='button' className='miniButton'>Открыть карточку дела</button>
                    </a>
                  }
                  {notif.type_of_notification=='Отправлено обращение в поддержку' && 
                    <a className={styles.additionalContent}>
                      <Link to='/view-feedback' className='miniButton'>Перейти</Link>
                    </a>
                  }
                  <a className={styles.xConteiner}>
                    <button type='button' className={`button ${styles.xMobile}`}>Скрыть уведомление</button>
                    <svg onClick={() => {hideNotification(notif.id)}} className={styles.x} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/></svg>
                  </a>
                </div>
            ))}
        </motion.div>
    </div>
    </>
  )
}

export default Inbox;